// Chakra Imports
import {
  Avatar,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  IconButton,
  Box,
  Input,
  VStack,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Spinner,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from "components-lib";
// Custom Components
// Removed unused menu item icons and ItemContent to slim bundle
import { BiSupport } from "react-icons/bi";
import { SidebarResponsive } from "components/sidebar/Sidebar";
import PropTypes from "prop-types";
import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
// Assets
import defaultRoutes from "routes.js";
// ThemeEditor removed for production light build
import ProfileSettingsModal from "./ProfileSettingsModal";
import { useToast } from "components-lib";
import ChatService from "services/chatService";
import ChatModal from "components/chat/ChatModal";
import { SidebarContext } from "contexts/SidebarContext";
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi";

export default function HeaderLinks(props) {
  const { secondary } = props;
  // Chakra Color Mode
  let menuBg = useColorModeValue("white", "navy.800");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)",
  );
  const navigate = useNavigate();
  const toast = useToast();
  const sidebarContext = useContext(SidebarContext);
  const isDesktopToggleAvailable = Boolean(
    sidebarContext && typeof sidebarContext.setIsSidebarCollapsed === "function"
  );
  const isSidebarCollapsed = Boolean(sidebarContext?.isSidebarCollapsed);
  const availableRoutes = props.routes && props.routes.length ? props.routes : defaultRoutes;

  // Profile modal state
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  
  // Chat modal state
  const {
    isOpen: isChatOpen,
    onOpen: onChatOpen,
    onClose: onChatClose,
  } = useDisclosure();

  const handleLogout = () => {
    // Clear all relevant storage items
    localStorage.removeItem("token");
    localStorage.removeItem("tokenPayload");
    localStorage.removeItem("doctorData");
    navigate("/login");
  };



  const getGreeting = () => {
    // Get all stored data
    const tokenPayloadStr = localStorage.getItem("tokenPayload");
    const doctorDataStr = localStorage.getItem("doctorData");
    localStorage.getItem("token");
    const user = localStorage.getItem("user");

    // console.log('=== DEBUG INFO ===');
    // console.log('Token exists:', !!token);
    // console.log('Raw tokenPayload:', tokenPayloadStr);
    // console.log('Raw doctorData:', doctorDataStr);

    try {
      const tokenPayload = tokenPayloadStr ? JSON.parse(tokenPayloadStr) : null;
      const doctorData = doctorDataStr ? JSON.parse(doctorDataStr) : null;

      // console.log('Parsed tokenPayload:', tokenPayload);
      // console.log('Parsed doctorData:', doctorData);
      // console.log('Role from token:', tokenPayload?.role);
      // console.log('Doctor name:', doctorData?.doctor);

      // Check for doctor role and data
      if ((tokenPayload?.role === "" || user?.doctor) && doctorData?.doctor) {
        console.log("Returning doctor greeting");
        return `Welcome, ${doctorData.doctor}`;
      }

      // Check for admin role
      if (tokenPayload?.role === "admin") {
        console.log("Returning admin greeting");
        return "Hey Admin";
      }

      // Get firstname from tokenPayload
      if (tokenPayload?.firstname) {
        console.log("Returning firstname greeting");
        return `Hey, ${tokenPayload.firstname}`;
      }

      // console.log('Falling back to default greeting');
      return "Hey, User";
    } catch (error) {
      console.error("Error in getGreeting:", error);
      return "Hey, User";
    }
  };

  const handleDesktopSidebarToggle = () => {
    if (isDesktopToggleAvailable) {
      sidebarContext.setIsSidebarCollapsed((prev) => !prev);
    }
  };

  return (
    <Flex
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
      gap="20px"
      zIndex={1001}
      position="relative"
      flexWrap={secondary ? { base: "wrap", md: "nowrap" } : "unset"}
    >
      <IconButton
        display={isDesktopToggleAvailable ? { base: "none", xl: "inline-flex" } : "none"}
        icon={isSidebarCollapsed ? <FiChevronsRight size="20px" /> : <FiChevronsLeft size="20px" />}
        variant="ghost"
        colorScheme="gray"
        aria-label={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        _hover={{ bg: "transparent" }}
        _active={{ bg: "transparent" }}
        _focus={{ boxShadow: "none" }}
        h="48px"
        w="48px"
        onClick={handleDesktopSidebarToggle}
      />
      <SidebarResponsive routes={availableRoutes} />
      <Box position="relative" zIndex={1002}>
        <IconButton
          icon={<BiSupport size="24px" right="4px" />}
          variant="ghost"
          colorScheme="gray"
          aria-label="Chat"
          _hover={{ bg: "transparent" }}
          _active={{ bg: "transparent" }}
          _focus={{ boxShadow: "none" }}
          h="48px"
          w="48px"
          onClick={onChatOpen}
        />
      </Box>

      <Box position="relative" zIndex={1002}>
        <Menu>
          <MenuButton
            p="0px"
            bg="transparent"
            _hover={{ bg: "transparent" }}
            _active={{ bg: "transparent" }}
            _focus={{ boxShadow: "none" }}
          >
            <Avatar
              _hover={{ cursor: "pointer" }}
              color="white"
              name={(() => {
                const tokenPayload = JSON.parse(
                  localStorage.getItem("tokenPayload") || "{}",
                );
                const doctorData = JSON.parse(
                  localStorage.getItem("doctorData") || "{}",
                );
                if (tokenPayload.role === "doctor" && doctorData.doctor) {
                  return doctorData.doctor;
                }
                return tokenPayload.firstname || "User";
              })()}
              bg="#11047A"
              size="sm"
              w="40px"
              h="40px"
            />
          </MenuButton>
          <MenuList
            boxShadow={shadow}
            p="0px"
            mt="10px"
            borderRadius="20px"
            bg={menuBg}
            border="none"
            zIndex={1003}
          >
            <Flex w="100%" mb="0px">
              <Text
                ps="20px"
                pt="16px"
                pb="10px"
                w="100%"
                borderBottom="1px solid"
                borderColor={borderColor}
                fontSize="sm"
                fontWeight="700"
                color={textColor}
              >
                👋&nbsp; {getGreeting()}
              </Text>
            </Flex>
            <Flex flexDirection="column" p="10px">
              <MenuItem
                _hover={{ bg: "none" }}
                _focus={{ bg: "none" }}
                borderRadius="8px"
                px="14px"
                onClick={() => setIsProfileModalOpen(true)}
              >
                <Text fontSize="sm">Profile Settings</Text>
              </MenuItem>
              <MenuItem
                _hover={{ bg: "none" }}
                _focus={{ bg: "none" }}
                color="red.400"
                borderRadius="8px"
                px="14px"
                onClick={handleLogout}
              >
                <Text fontSize="sm">Log out</Text>
              </MenuItem>
            </Flex>
          </MenuList>
        </Menu>
      </Box>

      <ProfileSettingsModal
        isOpen={isProfileModalOpen}
        onClose={() => setIsProfileModalOpen(false)}
      />

      {/* Chat Modal */}
      <ChatModal
        isOpen={isChatOpen}
        onClose={onChatClose}
        participant={{
          name: "Admin Support",
          sender_id: 1,
          sender_type: "admin",
          type: "admin"
        }}
        adminId={(() => {
          try {
            const userInfo = ChatService.getCurrentUserInfo();
            return userInfo.userId;
          } catch (error) {
            return 1; // fallback
          }
        })()}
        adminType={(() => {
          try {
            const userInfo = ChatService.getCurrentUserInfo();
            return userInfo.userType;
          } catch (error) {
            return 'admin'; // fallback
          }
        })()}
      />


      {/* Debug info */}
      {process.env.NODE_ENV === "development" && <Box display="none"></Box>}
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object),
};
